<template>
    <div id="navigation-mobile">
        <ul>
            <li>
                <router-link to="/">Home</router-link>
            </li>
            <li>
                <router-link to="/About">About</router-link>
            </li>
        </ul>
    </div>
</template>
<script>
export default{};
</script>

<style scoped>
    #navigation-mobile ul{
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
        position: fixed;
        top: 0;
        width: 300px;
    }
    #navigation-mobile li a:hover:not(.active){
        background-color: #eddbb2;
        color: black;
    }
    #navigation-mobile .active{
        background-color: #ff0000;
    }
    #navigation-mobile a{
        opacity: 1;
        text-decoration: none;
        padding: 6px 6px 6px 6px;
        font-size: 32px;
        display: block;
        transition: 0.3s;
        color: #eddbb2;
    }
</style>